<script lang="ts">
  import type { Page } from "state/page";
  import BottomActionBar from "./BottomActionBar.svelte";
  import { createMetadataQuery } from "state/queries/mimir";
  import { getSelectedIds, searchSelectionService } from "state/SelectionService";
  import { selectImageAction } from "./selectImageAction";
  import { getCloseCallback } from "config";

  export let state: Extract<Page, { type: "SEARCH" }>;

  $: itemIds = getSelectedIds($searchSelectionService);
  $: itemSource = state.activeSearchResultSource ?? "Bildebanken";

  // Implementation for single image select.
  //TODO: Implement for multiple selected images.
  $: hasSingleSelection = itemIds.length === 1;
  $: imageQuery = createMetadataQuery(itemIds[0], itemSource, {
    enabled: hasSingleSelection,
  });
  $: image = $imageQuery.isSuccess ? $imageQuery.data : undefined;
  $: disabled = imageSelected || !hasSingleSelection || !image || image.mediaType === "image/tiff";

  let imageSelected = false;

  async function onAction() {
    imageSelected = true;
    try {
      await selectImageAction({ itemId: itemIds[0], itemSource, image, altText: undefined });
    } finally {
      imageSelected = false;
    }
  }

  //VED MANGLENDE ALTTEXT GÅR VI TIL EDIT PER NÅ. SKAL VI HELLER GÅ TIL DETAIL.
</script>

<BottomActionBar
  label="Bruk bilde"
  {onAction}
  {disabled}
  busy={imageSelected}
  secondaryLabel="Avbryt"
  secondaryOnAction={getCloseCallback()}
/>
